import React, { useEffect, useState } from "react";
import { get } from "lodash";
import { bool, number, string } from "prop-types";
import { BrowserView, MobileView } from "react-device-detect";
import { DfpComponent } from "../../ads/dfp-component";
import { useSelector } from "react-redux";

const ListingAdSlot = ({ adType, index = 0, pageType, adStyleName, adSlotConfigName, showText = true }) => {
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const networkId = get(qtState, ["config", "ads-config", "network_id"], {});
  let pageConfig = get(qtState, ["config", "ads-config", "ad_slots", pageType], {});
  if (qtState.currentPath.includes("photos")) {
    pageConfig = get(qtState, ["config", "ads-config", "ad_slots", "photo-listing"], {});
  } else if (qtState.currentPath.includes("videos")) {
    pageConfig = get(qtState, ["config", "ads-config", "ad_slots", "video-listing"], {});
  }

  const desktopAdUnit = get(pageConfig, ["desktop", `${adType}`, "ad_unit"], "");
  const mobileAdUnit = get(pageConfig, ["mobile", `${adType}`, "ad_unit"], "");

  const [adComponent, setAdComponent] = useState();
  useEffect(() => {
    setAdComponent(
      <div className="ad-listing-wrapper">
        {desktopAdUnit && (
          <BrowserView>
            <DfpComponent
              adStyleName={adStyleName}
              id={`${pageType}-${adType}-${index + 1}`}
              path={`/${networkId}/${adType === "collection_ad" ? desktopAdUnit[index] : desktopAdUnit}`}
              adSlotConfigName={adSlotConfigName || "leaderboard_ad"}
              showText={showText}
            />
          </BrowserView>
        )}
        {mobileAdUnit && (
          <MobileView>
            <DfpComponent
              adStyleName={adStyleName}
              id={`${pageType}-${adType}-${index + 1}`}
              path={`/${networkId}/${mobileAdUnit}`}
              adSlotConfigName={adSlotConfigName || "mRec_ad"}
              showText={showText}
            />
          </MobileView>
        )}
      </div>
    );
  }, []);
  return <>{adComponent}</>;
};

ListingAdSlot.propTypes = {
  adType: string,
  headerSlotConfig: string,
  index: number,
  pageType: string,
  adStyleName: string,
  mobileOnly: bool,
  adSlotConfigName: string,
  showText: bool,
};

export default ListingAdSlot;
